module.exports = __webpack_public_path__ + "img/hic-ischemic-heart-disease-male.122eb0d5.png";